import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import './i18n/config';
import App from './App';
import { getCLS, getINP, getFCP, getLCP, getTTFB } from 'web-vitals';
import { trackPerformance } from './components/Matomo';

// Fonction pour reporter les Web Vitals
function reportWebVitals() {
  // Largest Contentful Paint
  getLCP((metric) => {
    trackPerformance('LCP', metric.value);
  });

  getINP((metric) => {
    trackPerformance('INP', metric.value);
  });

  getCLS((metric) => {
    trackPerformance('CLS', metric.value * 1000);
  });

  getFCP((metric) => {
    trackPerformance('FCP', metric.value);
  });

  getTTFB((metric) => {
    trackPerformance('TTFB', metric.value);
  });
}

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// Initialiser le reporting des Web Vitals
reportWebVitals();


